function addToCart(event) {
    event.preventDefault();

    const form = event.target;
    fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
    })
    .then(async () => {
        const res = await fetch("/cart.json");
        const cart = await res.json();

        // Actualiza el contador del carrito
        const cartCount = document.querySelector(".Header__CartCount");
        if (cartCount) {
            cartCount.textContent = cart.item_count;
            if (cart.item_count > 0) {
                cartCount.classList.add("is-visible");
            } else {
                cartCount.classList.remove("is-visible");
            }
        }
      
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}